import { Settings2, HeartHandshake, ShieldCheck } from "lucide-react";
import { WHY_US } from "../data/content";
import { Reveal } from "./Reveal";

const ICONS = { Settings2, HeartHandshake, ShieldCheck };

export const WhyFreshFast = ({ compact = false }) => {
  return (
    <section id="why-us" data-testid="why-us-section" className={`${compact ? "py-10 sm:py-14 lg:py-16" : "py-16 sm:py-20 lg:py-28"} bg-white`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className={`grid ${compact ? "" : "lg:grid-cols-12"} gap-10 lg:gap-16 items-start`}>
          {!compact && (
            <div className="lg:col-span-5">
              <Reveal>
                <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal">
                  Why Fresh Fast Foods
                </p>
              </Reveal>
              <Reveal delay={1}>
                <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-charcoal leading-[1.05]">
                  Food Service Experience
                  <br />
                  You Can Trust.
                </h2>
              </Reveal>
              <Reveal delay={2}>
                <p className="mt-5 text-[15px] lg:text-[17px] text-brand-charcoal/75 leading-relaxed">
                  Fresh Fast Foods LLC is a food service company built on quality food,
                  professional service, and community impact. Our team combines the speed
                  and consistency of BTWNYC quick-service restaurant operations with the
                  flexibility of custom catering. We understand timing, packaging,
                  presentation, portion control, and the importance of showing up ready.
                </p>
              </Reveal>
            </div>
          )}

          <div className={`${compact ? "" : "lg:col-span-7"} grid sm:grid-cols-1 gap-4`}>
            {WHY_US.map((w, i) => {
              const Icon = ICONS[w.icon] || ShieldCheck;
              return (
                <Reveal key={w.title} delay={Math.min(i + 1, 4)}>
                  <div
                    data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group flex gap-5 rounded-3xl bg-brand-cream border border-black/5 p-6 sm:p-7 transition-all hover:bg-white hover:border-brand-teal/30 hover:shadow-[0_22px_40px_-22px_rgba(17,17,17,0.25)] hover:-translate-y-0.5"
                  >
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-charcoal text-brand-gold group-hover:bg-brand-teal group-hover:text-white transition-colors">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div>
                      <h3 className="font-display font-bold text-[20px] text-brand-charcoal tracking-tight">
                        {w.title}
                      </h3>
                      <p className="mt-1.5 text-[14.5px] text-brand-charcoal/70 leading-relaxed">
                        {w.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyFreshFast;
